import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiUserHelperService {
  getCivility(user: any, defaultValue = '') {
    if (user?.civility === 'sir') {
      return 'Mr';
    }
    if (user?.civility === 'mrs') {
      return 'Mme';
    }
    return defaultValue;
  }

  getFullName(user: any, civility: boolean = true) {
    if (!user) {
      return null;
    }
    let result = '',
      comma = '';
    if (civility && user.civility === 'sir') {
      result += 'Mr';
      comma = ' ';
    }
    if (civility && user.civility === 'mrs') {
      result += 'Mme';
      comma = ' ';
    }
    if (user.firstName) {
      result += comma + user.firstName;
      comma = ' ';
    }
    if (user.lastName) {
      result += comma + user.lastName;
    }
    return result ?? null;
  }
}
